<template>
  <AsyncPage
    :loader="useCreditLoader"
    :page-component="Credit"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useCreditLoader } from "./Credit.loader.ts";
import { AsyncPage } from "@saflib/vue/components";
const Credit = defineAsyncComponent(
  () => import("./Credit.vue"),
);
</script>
